import { auth } from '../firebase';

export interface RunwareGenerationResult {
  success: boolean;
  imageUrl?: string;
  error?: string;
}

const getAdminToken = async (): Promise<string> => {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error('Sessione amministratore non disponibile');
  return token;
};

/**
 * Genera un avatar usando endpoint server-side Firebase Functions.
 */
export async function generateAvatarWithRunware(
  name: string,
  bio: string,
  personality?: string
): Promise<RunwareGenerationResult> {
  try {
    console.log('🎨 [IMAGEN] Generazione avatar via API server per:', name);

    const response = await fetch('/api/generate-avatar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await getAdminToken()}`,
      },
      body: JSON.stringify({
        name,
        bio,
        personality,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `Errore HTTP ${response.status}`);
    }

    const result = await response.json();
    if (!result?.success || !result?.imageUrl) {
      return {
        success: false,
        error: result?.error || 'Nessuna immagine generata',
      };
    }

    return {
      success: true,
      imageUrl: result.imageUrl,
    };
  } catch (error) {
    console.error('❌ [IMAGEN] Errore generazione avatar:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Errore sconosciuto',
    };
  }
}
